module.exports = __webpack_public_path__ + "static/media/tg.5e565ac5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tg.svg
// module id = 262
// module chunks = 0